export class RecaptchaService {
  public getRecaptchaToken = async (): Promise<string> =>
    window.grecaptcha.execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY);
}

export const recaptchaService = new RecaptchaService();
